/**
 * Resolve post-login dashboard route from user category/role.
 *
 * SECURITY: unknown or null category must NOT fall back to the customer UI —
 * that silent default turns a data bug into a tenant-isolation failure.
 */

const KNOWN_CATEGORY_ROUTES = {
  platform_user: '/platform/dashboard',
  platform_admin: '/platform/dashboard',
  platform: '/platform/dashboard',
  investor: '/investor/dashboard',
  funder: '/investor/dashboard',
  halifund: '/investor/dashboard',
  halitrade: '/haliagent/dashboard',
  haliagent: '/haliagent/dashboard',
  agent: '/haliagent/dashboard',
  referral: '/haliagent/dashboard',
  halilab: '/halilab/dashboard',
  customer: '/customer/dashboard',
  buyer: '/buyer/dashboard',
};

class UnknownUserCategoryError extends Error {
  constructor(category, role) {
    super(
      `Unknown or missing user category "${category || ''}"` +
        (role ? ` (role=${role})` : '') +
        '. Refusing to default to customer UI.'
    );
    this.name = 'UnknownUserCategoryError';
    this.category = category;
    this.role = role;
  }
}

/**
 * @param {string|null|undefined} category
 * @param {string|null|undefined} role
 * @returns {string} dashboard path
 * @throws {UnknownUserCategoryError}
 */
function getUserDashboardRoute(category, role) {
  const cat = String(category || '').toLowerCase().trim();
  const r = String(role || '').toLowerCase().trim();

  if (!cat) {
    // Role-only signals that still identify a known persona (legacy rows)
    if (r === 'admin') return '/platform/dashboard';
    if (r.includes('investor')) return '/investor/dashboard';
    if (r === 'agent' || r === 'referral') return '/haliagent/dashboard';
    throw new UnknownUserCategoryError(category, role);
  }

  if (KNOWN_CATEGORY_ROUTES[cat]) {
    return KNOWN_CATEGORY_ROUTES[cat];
  }
  if (cat.includes('platform')) return '/platform/dashboard';
  if (cat.includes('investor') || cat.includes('funder')) return '/investor/dashboard';
  if (cat.includes('halitrade') || cat.includes('agent')) return '/haliagent/dashboard';
  if (cat.includes('halilab') || cat === 'halisoft') return '/halilab/dashboard';
  if (cat.includes('customer')) return '/customer/dashboard';

  throw new UnknownUserCategoryError(category, role);
}

module.exports = {
  getUserDashboardRoute,
  UnknownUserCategoryError,
  KNOWN_CATEGORY_ROUTES,
};
module.exports.__esModule = true;
module.exports.default = getUserDashboardRoute;
